/**
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
*/

import { AutoCompleteModule } from 'primeng/autocomplete';
import { CheckboxModule } from 'primeng/checkbox';
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { RadioButtonModule } from 'primeng/radiobutton';
import { SplitButtonModule } from 'primeng/splitbutton';
import { VirtualScrollerModule } from 'primeng/virtualscroller';
import { TableModule } from 'primeng/table';
import { MenuModule } from 'primeng/menu';
import { SpinnerModule } from 'primeng/spinner';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AddToPendingService } from './shared/services/add-to-pending.service';
import { CommonModule } from '@angular/common';
import { CoreModule } from './../core/core.module';
import { LmsTerminalBoundComponent } from './status/lms-terminal-bound/lms-terminal-bound.component';
import { LmsTerminalBoundListComponent } from './status/lms-terminal-bound-list/lms-terminal-bound-list.component';
import { LmsTerminalBoundStatusComponent } from './status/lms-terminal-bound-status/lms-terminal-bound-status.component';
import { LmsTerminalBoundStatusListComponent } from './status/lms-terminal-bound-status-list/lms-terminal-bound-status-list.component';
import { LmsTerminalComponent } from './terminal.component';
import { LmsTerminalHandlingComponent } from './handling/terminal-handling.component';
import { LmsTerminalHandlingHeaderComponent } from './handling/lms-terminal-handling-header/lms-terminal-handling-header.component';
import { LmsTerminalInboundListComponent } from './handling/lms-terminal-inbound-list/lms-terminal-inbound-list.component';
import { LmsTerminalNotesComponent } from './notes/terminal-notes.component';
import { LmsTerminalOnTerminalListComponent } from './handling/lms-terminal-on-terminal-list/lms-terminal-on-terminal-list.component';
import { LmsTerminalPendingActionsComponent } from './status/lms-terminal-pending-actions/lms-terminal-pending-actions.component';
import { LmsTerminalStatusComponent } from './status/terminal-status.component';
import { LmsTerminalStatusHeaderComponent } from './status/lms-terminal-status-header/lms-terminal-status-header.component';
import { LmsTerminalViewStatusComponent } from './status/lms-terminal-view-status/lms-terminal-view-status.component';
import { NgModule } from '@angular/core';
import { OrderBy } from './shared/pipes/order-by';
import { SharedModule } from '../shared/shared.module';
import { TerminalConfigService } from './shared/services/terminal-config.service';
import { TerminalHandlingResolver } from './shared/terminal-handling.resolver';
import { TerminalHandlingService } from './shared/services/terminal-handling.service';
import { TerminalNotesResolver } from './shared/terminal-notes.resolver';
import { TerminalRoutingModule } from './terminal-routing.module';
import { TerminalStatusResolver } from './shared/terminal-status.resolver';
import { TerminalStatusService } from './shared/services/terminal-status.service';
import { TerminalStatusCarouselComponent } from './status/terminal-status-carousel/terminal-status-carousel.component';

/**
 * @export
 * @class TerminalModule
 */

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    OverlayPanelModule,
    SpinnerModule,
    DropdownModule,
    DialogModule,
    FormsModule,
    CheckboxModule,
    ReactiveFormsModule,
    TerminalRoutingModule,
    VirtualScrollerModule,
    TableModule,
    AutoCompleteModule,
    RadioButtonModule,
    CoreModule,
    SplitButtonModule,
    MenuModule
  ],
  providers: [TerminalStatusService, TerminalConfigService,
    TerminalHandlingResolver, TerminalStatusResolver,
    TerminalNotesResolver,
    TerminalHandlingService, AddToPendingService],
  declarations: [LmsTerminalComponent,
    LmsTerminalStatusHeaderComponent,
    LmsTerminalBoundComponent,
    LmsTerminalBoundStatusComponent,
    LmsTerminalBoundStatusListComponent,
    LmsTerminalBoundListComponent,
    LmsTerminalViewStatusComponent,
    LmsTerminalHandlingComponent,
    LmsTerminalNotesComponent,
    LmsTerminalStatusComponent,
    LmsTerminalInboundListComponent,
    LmsTerminalOnTerminalListComponent,
    LmsTerminalHandlingHeaderComponent,
    LmsTerminalPendingActionsComponent,
    OrderBy,
    TerminalStatusCarouselComponent],
  exports: [LmsTerminalComponent, OrderBy]
})
export class TerminalModule { }
